import { mathRound } from '../../../../utils/mathRound';

export const useColumns = (groupby) => [
  {
    headerName: groupby === 'Emp' ? 'Accrual Type' : 'Employee',
    field: 'name',
  },
  {
    headerName: 'Start Balance',
    field: 'start',
    renderCell: (value) => mathRound(value),
  },
  {
    headerName: 'Earned',
    field: 'earned',
    renderCell: (value) => mathRound(value),
  },
  {
    headerName: 'Total',
    field: 'total',
    renderCell: (value) => mathRound(value),
  },
  {
    headerName: 'Used',
    field: 'used',
    renderCell: (value) => mathRound(value),
  },
  {
    headerName: 'Planned',
    field: 'planned',
    renderCell: (value) => mathRound(value),
  },
  {
    headerName: 'Remaining Balance',
    field: 'remaining',
    renderCell: (value) => mathRound(value),
  },
];
